import { useState, useEffect } from 'react';
import { fetchDataAuthenticated } from '../utilities/HttpUtils';

import useAlert from '../Components/Alerts/useAlert';

export function usePrivileges() {
    const _apiUrl = window.runtimeConfig.WEBSITE_BACKEND_URI;

    const [contributor, setContributor] = useState();
    const [admin, setAdmin] = useState();
    const [loading, setLoading] = useState(true);

    const { setAlert } = useAlert();

    useEffect(() => {
        getPrivileges();
    }, []);

    async function getPrivileges() {

        let contributor = await getAuthenticatedAccountPrivilege("Contributor");
        setContributor(contributor);

        let admin = await getAuthenticatedAccountPrivilege("Admin");
        setAdmin(admin)
    }

    async function getAuthenticatedAccountPrivilege(privilegeName) {
        let accessGranted = false;
        await fetchDataAuthenticated(_apiUrl + `api/user/checkPrivilege?privilegeName=${privilegeName}`)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(accountHasPrivilege => {
                accessGranted = accountHasPrivilege
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            });

        return accessGranted;
    }

    return { contributor, admin, loading };
}

export function useListPrivileges() {
    const _apiUrl = window.runtimeConfig.WEBSITE_BACKEND_URI;

    const [loading, setLoading] = useState(true);

    const [privileges, setPrivileges] = useState();

    const { setAlert } = useAlert();

    useEffect(() => {
        getPrivileges();
    }, []);

    async function getPrivileges () {
        await fetchDataAuthenticated(_apiUrl + `api/user/privileges`)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                setPrivileges(data);
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return { privileges, loading };
}
